export const Overlay: React.FC = ({ children }) => (
    <div className="fixed z-10 inset-0 overflow-y-auto bg-black bg-opacity-75">
        <div className="flex items-center justify-center min-h-screen text-center">
            <div className="relative">
                {children}
            </div>
        </div>
    </div>
);